// extracted by mini-css-extract-plugin
export default {"carousel":"style-module--carousel--ca039","list":"style-module--list--0d368","callToAction":"style-module--call-to-action--19dec"};